import { useLocale } from "../../../hooks/useLocale";
import { msg } from "../../../locales/translate";
import { Box, VBox } from "@ui/box/Box";
import { CreditCard, Globe, Users } from "lucide-react";
import { Error } from "@ui/error/Error";
import { Page } from "@ui/page/Page";
import Spacer from "@ui/spacer/Spacer";
import { Spinner } from "@ui/spinner/Spinner";
import { TabItem, Tabs } from "@ui/tabs/Tabs";
import { Typo } from "@ui/text/Typo";
import { useEffect, useState } from "react";
import { GD } from "src/GD";
import { useRouter } from "src/services/Router";
import { ClientGroups } from "src/view/conponents/list/ClientGroups";
import { Clients } from "src/view/conponents/list/Clients";
import { Sessions } from "src/view/forms/Sessions";
import { IconBlock } from "../registerPage/Icons";
import { IClient } from "src/services/ClientService";
import { hasRole } from "src/permissions";

export const MerchantGeneralPage = () => {
	useLocale();
	const [project] = GD.REQ_CURRENT_PROJECT.useRequest();
	const [user] = GD.REQ_PROFILE.useValue(undefined, undefined, [project]);
	const router = useRouter();
	//const label = project && project?.name + " Clients";
	const label = msg("yourClients");

	const [error, setError] = useState<IError | null>(null);

	const [showClients, setShowClients] = useState<boolean>(false);
	const [showContactSupport, setShowContactSupport] = useState<undefined | IClient>(undefined);
	const [showPayswixWelcome, setShowPayswixWelcome] = useState(false);

	useEffect(() => {
		fetchClients();
	}, [project, user]);

	// STATUSES: ["created", "submitted", "aml_review", "rejected", "board_review", "active", "blocked", "deleted"],
	const fetchClients = async () => {
		if (!project || !user) return;

		setError(null);
		setShowClients(false);
		setShowContactSupport(undefined);
		setShowPayswixWelcome(false);

		const userProject = user.projects.find(val => val.id === project.id);
		const canUseRegistration = hasRole(userProject?.roles, "merchant") && project.id !== 3;
		const isClientAvailable = (client: IClient) => client.status === "active" || client.status === "aml_review" || client.status === "board_review";

		const clients = await GD.REQ_CLIENTS.request({});
		if (clients) {
			{
				if (clients.error) {
					if (clients.error.code === 13) {
						if (project.id === 3) {
							setShowPayswixWelcome(true);
						} else if (canUseRegistration) {
							router.navigate("register");
						} else {
							setError(clients.error);
						}
					} else {
						setError(clients.error);
					}
				} else {
					if (clients.data && Array.isArray(clients.data)) {
						const availableClients = clients.data.filter(isClientAvailable);

						if (project.id === 3 && availableClients.length === 0) {
							setShowPayswixWelcome(true);
							return;
						}

						if (clients.data.length === 0) {
							if (canUseRegistration) {
								router.navigate("register");
							} else {
								setShowPayswixWelcome(true);
							}
						} else if (clients.data.length === 1) {
							const clientStatus = clients.data[0].status;

							if (isClientAvailable(clients.data[0])) {
								router.navigate("client", { cid: clients.data[0].id + "" });
							} else if (clientStatus === "deleted" || clientStatus === "blocked") {
								setShowContactSupport(clients.data[0]);
							} else {
								if (canUseRegistration) {
									router.navigate("registerClient", { rid: clients.data[0].id + "" });
								} else {
									setShowPayswixWelcome(true);
								}
							}
						} else if (clients.data.length > 1) {
							if (availableClients.length > 0) {
								setShowClients(true);
							} else if (canUseRegistration) {
								router.navigate("register");
							} else {
								setShowPayswixWelcome(true);
							}
						}
					}
				}
			}
		}
	};

	if (!showClients && !error && !showContactSupport && !showPayswixWelcome) {
		return (
			<Box sx={{ width: "100%", height: "100%", display: "flex", alignItems: "center", justifyContent: "center" }}>
				<Spinner />
			</Box>
		);
	}

	return (
		<Page
			label={showClients ? (label ?? "") : ""}
			// rightSection={<RightSectionClients />}
			sectionRightContent={
				<>
					{/* <Button onClick={onAdd} title="Add Client" variant="primarySmall" /> */}
					{/* <Button
						onClick={() => {
							S_CONFIRM.invoke({
								message: "Are you sure?",
								onResult: (_val: "confirm" | "reject") => {},
							});
						}}
						title="TEST CONFIRM"
						variant="primarySmall"
					/> */}
				</>
			}
			description={showClients ? msg("selectAClientToManage") : undefined}>
			{error && <Error error={error} />}
			{showPayswixWelcome && (
				<Box sx={{ overflowY: "auto", height: "100%", width: "100%", position: "relative" }}>
					<VBox
						sx={{
							padding: "40px",
							alignItems: "center",
							justifyContent: "center",
						}}>
						<VBox
							sx={{
								alignContent: "center",
								alignItems: "center",
								maxWidth: "700px",
								textAlign: "center",
								padding: "60px",
								backgroundColor: "#ffffff",
								borderRadius: "10px",
								boxShadow: "0 3px 6px rgba(0, 0, 0, 0.08)",
							}}>
							<Box
								sx={{
									width: "80px",
									height: "80px",
									borderRadius: "50%",
									display: "flex",
									alignItems: "center",
									justifyContent: "center",
								}}>
								<IconBlock color="#2142D7" />
							</Box>

							<Typo variant="head" bold sx={{ marginBottom: "10px", color: "#1a1a2e" }}>{msg("welcomeToPayswix")}</Typo>

							<Spacer size="10px" />

							<Typo
								variant="text"
								sx={{
									color: "#64748b",
									lineHeight: "1.4",
								}}>{msg("yourClientAccountIsBeingPreparedOnceAccessIsAssignedAvailabl_6b3cacff")}</Typo>
						</VBox>
					</VBox>
				</Box>
			)}
			{showClients && (
				<Tabs
					variant="modern"
				// checkFeature={feature => checkFeature(feature as any)}
				>
					<TabItem title={msg("clients")} icon={<Users size={16} />}>
						<Clients hideControls />
					</TabItem>

					<TabItem title={msg("websites")} icon={<Globe size={16} />}>
						{/* <MerchantGroups internal={true} /> */}
						<ClientGroups hideControls />
						{/* <Clients hideControls /> */}
					</TabItem>

					<TabItem title={msg("payments")} icon={<CreditCard size={16} />}>
						<Sessions target_id={0} target_type="merchant" />
					</TabItem>
				</Tabs>
			)}
			{showContactSupport && (
				<Box sx={{ overflowY: "auto", height: "100%", width: "100%", position: "relative" }}>
					<VBox
						sx={{
							padding: "40px",
							alignItems: "center",
							justifyContent: "center",
						}}>
						<VBox
							sx={{
								alignContent: "center",
								alignItems: "center",
								maxWidth: "700px",
								textAlign: "center",
								padding: "60px",
								backgroundColor: "#ffffff",
								borderRadius: "10px",
								boxShadow: "0 3px 6px rgba(0, 0, 0, 0.08)",
							}}>
							<Box
								sx={{
									width: "80px",
									height: "80px",
									borderRadius: "50%",
									display: "flex",
									alignItems: "center",
									justifyContent: "center",
								}}>
								<IconBlock color="#ff9100" />
							</Box>

							<Typo variant="headMedium" bold sx={{ marginBottom: "10px", color: "#1a1a2e" }}>
								{msg("templateClient_482c6cf8", { v0: showContactSupport?.name ?? "" })}
							</Typo>

							<Typo variant="head" bold sx={{ marginBottom: "10px", color: "#1a1a2e" }}>{msg("thisMerchantAccountHasBeenClosed")}</Typo>

							<Spacer size="10px" />

							<Typo
								variant="text"
								sx={{
									color: "#64748b",
									lineHeight: "1.4",
								}}>{msg("forAssistanceOrFutherDetailsPleaseContactYourAquirerSRepresentative")}</Typo>

							

							
						</VBox>
					</VBox>
				</Box>
			)}
		</Page>
	);
};

// const RightSectionClients = ({}) => {
// 	return (
// 		<Box
// 			sx={{
// 				display: "flex",
// 				flex: 1,
// 				minHeight: "0px",
// 				flexDirection: "column",

// 				gap: "10px",
// 			}}>
// 			<Comments sectionType={0} targetId={1} targetType="client" />
// 			<Events targetId={1} targetType="client" />
// 		</Box>
// 	);
// };
